import {
    getConfig,
    updateConfig,
    createConfig,
    deleteConfig,
    getConfigWithCancelToken,
} from "@services/alert/config";
import { getServer } from "@services/server";
import { getBridge } from "@/services/bridge";
import { getSecurity } from "@services/security";
import { getSymbol } from "@services/symbol";
import { getOptions } from "@services/alert/config-options";
import store from "@store/store";
import i18n from "@/i18n";

const state = {
    configData: [],
    updated: false,
    errorOccur: false,
    loading: true,
    tabName: "",
    serverOptions: [],
    bridgeOptions: [],
    securityOptions: [],
    symbolOptions: [],
    headerOptions: {
        "Fast Trade": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.durationThreshold"),
                value: "duration_threshold",
            },
            {
                text: i18n.t("common.table.volumeThreshold"),
                value: "volume_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Large Exposure": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.exposureThreshold"),
                value: "exposure_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.symbolRegex"),
                value: "symbol_regx",
            },
            {
                text: i18n.t("common.table.groupRegx"),
                value: "group_regx",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Large Volume": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.symbolRegex"),
                value: "symbol_regx",
            },
            {
                text: i18n.t("common.table.symbolGroup"),
                value: "symbol_group",
            },
            {
                text: i18n.t("common.table.volumeThreshold"),
                value: "volume_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Large Volume USD": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.volumeUSDThreshold"),
                value: "volume_usd_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Locking Position": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.lockVolumeThreshold"),
                value: "lock_volume_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.symbolRegex"),
                value: "symbol_regx",
            },
            {
                text: i18n.t("common.table.symbolGroup"),
                value: "symbol_group",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        Mandate: [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.volumeThreshold"),
                value: "volume_threshold",
            },
            {
                text: i18n.t("common.table.profitThreshold"),
                value: "profit_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.symbolRegex"),
                value: "symbol_regx",
            },
            {
                text: i18n.t("common.table.symbolGroup"),
                value: "symbol_group",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Profit Taker": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.profitThreshold"),
                value: "profit_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.symbolRegex"),
                value: "symbol_regx",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Watch List": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.loginList"),
                value: "login_list",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Same Direction": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.bookFilter"),
                value: "book_filter",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.volumeThreshold"),
                value: "volume_threshold",
            },
            {
                text: i18n.t("common.table.intervalThreshold"),
                value: "interval_threshold",
            },
            {
                text: i18n.t("common.table.numberThreshold"),
                value: "number_threshold",
            },
            {
                text: i18n.t("common.table.minimumVolumeThreshold"),
                value: "minimum_volume_threshold",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Trade On Credit": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.equityCreditRatioThreshold"),
                value: "equity_credit_ratio_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.bookRegx"),
                value: "book_regx",
            },
            {
                text: i18n.t("common.table.groupRegx"),
                value: "group_regx",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Daily Winner": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.closeProfitThreshold"),
                value: "close_profit_threshold",
            },
            {
                text: "Book",
                value: "books",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Daily Loser": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.closeProfitThreshold"),
                value: "close_profit_threshold",
            },
            {
                text: "Book",
                value: "books",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Large Exposure Volume": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.volumeThreshold"),
                value: "volume_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.symbolRegex"),
                value: "symbol_regx",
            },
            {
                text: i18n.t("common.table.groupRegx"),
                value: "group_regx",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Deposit Withdrawal": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.withdrawDepositThreshold"),
                value: "withdraw_deposit_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.bookRegx"),
                value: "book_regx",
            },
            {
                text: i18n.t("common.table.groupRegx"),
                value: "group_regx",
            },
            {
                text: i18n.t("common.table.loginList"),
                value: "login_list",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Time Decay": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.sensitivity"),
                value: "sensitivity",
            },
            {
                text: i18n.t("common.table.bookFilter"),
                value: "book_filter",
            },
            {
                text: i18n.t("common.table.numberOfTrades"),
                value: "number_of_trades",
            },
            {
                text: i18n.t("common.table.pnlThreshold"),
                value: "pnl_threshold",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "High Volume USD": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.bookFilter"),
                value: "book_filter",
            },
            {
                text: i18n.t("common.table.stdLotThreshold"),
                value: "volume_usd_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "High Trades": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.bookFilter"),
                value: "book_filter",
            },
            {
                text: i18n.t("common.table.tradeCountThreshold"),
                value: "trade_count_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Large PNL": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.bookFilter"),
                value: "book_filter",
            },
            {
                text: i18n.t("common.table.pnlUsdThreshold"),
                value: "pnl_usd_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Low Liquidity Arbitrage": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_id",
            },
            {
                text: i18n.t("common.table.bookFilter"),
                value: "book_filter",
            },
            {
                text: i18n.t("common.table.pnlThreshold"),
                value: "pnl_threshold",
            },
            {
                text: i18n.t("common.table.priority"),
                value: "priority",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        Tick: [
            {
                text: "Id",
                value: "id",
            },
            {
                text: i18n.t("common.table.server"),
                value: "server_name",
            },
            {
                text: i18n.t("common.table.symbol"),
                value: "symbol",
            },
            {
                text: i18n.t("common.table.security"),
                value: "security",
            },
            {
                text: i18n.t("common.table.continuousCount"),
                value: "continuous_count",
            },
            {
                text: i18n.t("common.table.secondsThreshold"),
                value: "seconds_threshold",
            },
            {
                text: i18n.t("common.table.emailThreshold"),
                value: "email_threshold",
            },
            {
                text: "Telegram ID",
                value: "telegram_id",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
        "Tick Bridge": [
            {
                text: "Id",
                value: "id",
            },
            {
                text: "Bridge",
                value: "bridge_name",
            },
            {
                text: i18n.t("common.table.symbol"),
                value: "symbol",
            },
            {
                text: i18n.t("common.table.continuousCount"),
                value: "continuous_count",
            },
            {
                text: i18n.t("common.table.secondsThreshold"),
                value: "seconds_threshold",
            },
            {
                text: i18n.t("common.table.emailThreshold"),
                value: "email_threshold",
            },
            {
                text: "Telegram ID",
                value: "telegram_id",
            },
            {
                text: i18n.t("common.table.createdAt"),
                value: "created_at",
            },
            {
                text: i18n.t("common.table.updatedAt"),
                value: "updated_at",
            },
            {
                text: i18n.t("common.table.actions"),
                value: "actions",
                sortable: false,
                fixed: true,
            },
        ],
    },
    csvFields: {
        "Fast Trade": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Duration Threshold": "duration_threshold",
            "Volume Threshold": "volume_threshold",
            Priority: "priority",
        },
        "Large Exposure": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Exposure Threshold": "exposure_threshold",
            Priority: "priority",
            "Symbol Regx": "symbol_regx",
            "Group Regx": "group_regx",
        },
        "Large Volume": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Symbol Regx": "symbol_regx",
            "Symbol Group": "symbol_group",
            "Volume Threshold": "volume_threshold",
            Priority: "priority",
        },
        "Large Volume USD": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Volume USD Threshold": "volume_usd_threshold",
            Priority: "priority",
        },
        "Locking Position": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Lock Volume Threshold": "lock_volume_threshold",
            Priority: "priority",
            "Symbol Regx": "symbol_regx",
            "Symbol Group": "symbol_group",
        },
        Mandate: {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Volume Threshold": "volume_threshold",
            "Profit Threshold": "profit_threshold",
            Priority: "priority",
            "Symbol Regx": "symbol_regx",
            "Group Regx": "symbol_group",
        },
        "Profit Taker": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Profit Threshold": "profit_threshold",
            Priority: "priority",
            "Symbol Regx": "symbol_regx",
            "Group Regx": "group_regx",
        },
        "Watch List": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            Priority: "priority",
            "Book Regx": "book_regx",
            "Group Regx": "group_regx",
            "Login List": "login_list",
            "Enable Notification": "enable_notification",
            "Notification Rule": "notification_rule",
        },
        "Same Direction": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            Priority: "priority",
            "Volume Threshold": "volume_threshold",
            "Interval Threshold": "interval_threshold",
            "Number Threshold": "number_threshold",
            "Minimum Volume Threshold": "minimum_volume_threshold",
            "Book Filter": "book_filter",
        },
        "Trade On Credit": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Equity Credit Ratio Threshold": "equity_credit_ratio_threshold",
            Priority: "priority",
            "Book Regx": "book_regx",
            "Group Regx": "group_regx",
        },
        "Daily Winner": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Close Profit Threshold": "close_profit_threshold",
            Book: "books",
            Priority: "priority",
        },
        "Daily Loser": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Close Profit Threshold": "close_profit_threshold",
            Book: "books",
            Priority: "priority",
        },
        "Large Exposure Volume": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Volume Threshold": "volume_threshold",
            Priority: "priority",
            "Symbol Regx": "symbol_regx",
            "Group Regx": "group_regx",
        },
        "Deposit Withdrawal": {
            ID: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Withdrawal Deposit Threshold": "withdraw_deposit_threshold",
            Priority: "priority",
            "Book Regx": "book_regx",
            "Group Regx": "group_regx",
            "Login List": "login_list",
        },
        Tick: {
            ID: "id",
            Server: "server_id",
            "Server Name": "server_name",
            Symbol: "symbol",
            Security: "security",
            "Continuous Count": "continuous_count",
            "Seconds Threshold": "seconds_threshold",
            "Email Threshold": "email_threshold",
            "Telegram ID": "telegram_id",
        },
        "Tick Bridge": {
            ID: "id",
            Bridge: "bridge_id",
            "Bridge Name": "bridge_name",
            Symbol: "symbol",
            "Continuous Count": "continuous_count",
            "Seconds Threshold": "seconds_threshold",
            "Email Threshold": "email_threshold",
            "Telegram ID": "telegram_id",
        },
        "High Volume USD": {
            Id: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Volume USDThreshold": "volume_usd_threshold",
            Priority: "priority",
        },
        "High Trades": {
            Id: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Trade Count Threshold": "trade_count_threshold",
            Priority: "priority",
        },
        "Large PNL": {
            Id: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Pnl Usd Threshold": "pnl_usd_threshold",
            Priority: "priority",
        },
        "Low Liquidity Arbitrage": {
            Id: "id",
            "Broker ID": "broker_id",
            Server: "server_id",
            "Pnl Threshold": "pnl_threshold",
            Priority: "priority",
        },
    },
    configDialog: false,
    selectedAlertConfig: "",
    options: {
        symbol_regx: [],
        group_regx: [],
        symbol_group: [],
        book_regx: [],
        filter_login: [],
    },
    alertHubRelatedTypes: [
        "Fast Trade",
        "High Volume USD",
        "High Trades",
        "Large PNL",
        "Low Liquidity Arbitrage",
    ],
};

const actions = {
    getConfigDataAction({ commit }, data) {
        if (typeof data === "string") {
            commit("UPDATE_LOADING", true);
            const typeName = data.toLowerCase().replaceAll(" ", "-");
            commit("CHANGE_TAB", typeName);
            getConfig(typeName).then((res) => {
                commit("GET_CONFIG_DATA", res.data);
                commit("UPDATE_LOADING", false);
            });
        } else {
            commit("UPDATE_LOADING", true);
            const typeName = data.tabName.toLowerCase().replaceAll(" ", "-");
            commit("CHANGE_TAB", typeName);
            getConfigWithCancelToken(typeName, data.cancelTokenSource).then(
                (res) => {
                    commit("GET_CONFIG_DATA", res.data);
                    commit("UPDATE_LOADING", false);
                }
            );
        }
    },
    updateConfigDataAction({ commit }, data) {
        const typeName = data.type.toLowerCase().replaceAll(" ", "-");
        if (
            Object.keys(data).includes("book_filter") &&
            !!data["book_filter"]
        ) {
            data["book_filter"] = data["book_filter"].join(";");
        }
        commit("CHANGE_UPDATE_STATUS", false);
        commit("UPDATE_LOADING", true);
        updateConfig(typeName, data).then((res) => {
            store.state.snackcolor = "green";
            store.state.snackbar = true;
            store.state.snackmsg = res.data.msg;
            commit("CHANGE_UPDATE_STATUS", true);
        });
    },
    createConfigDataAction({ commit }, data) {
        const typeName = data?.type.toLowerCase().replaceAll(" ", "-");
        if (
            Object.keys(data).includes("book_filter") &&
            !!data["book_filter"]
        ) {
            data["book_filter"] = data["book_filter"].join(";");
        }
        commit("CHANGE_UPDATE_STATUS", false);
        commit("UPDATE_LOADING", true);
        createConfig(typeName, data)
            .then((res) => {
                store.state.snackcolor = "green";
                store.state.snackbar = true;
                store.state.snackmsg = res.data.msg;
                commit("CHANGE_UPDATE_STATUS", true);
            })
            .catch(({ response }) => {
                if (response.status == 409) {
                    let snackbar = {
                        message:
                            response.data.msg +
                            ", " +
                            i18n.t("settings.alert.chooseAnotherName"),
                        color: "red",
                        btnName: "Close",
                        status: true,
                        timeout: 3000,
                    };
                    commit("UPDATE_SNACKBAR", snackbar, { root: true });
                    commit("UPDATE_LOADING", false);
                    commit("CHANGE_ERROR_STATUS", true);
                }
            });
    },
    deleteConfigDataAction({ commit }, data) {
        const typeName = data.type.toLowerCase().replaceAll(" ", "-");
        commit("CHANGE_UPDATE_STATUS", false);
        commit("UPDATE_LOADING", true);
        deleteConfig(typeName, data).then((res) => {
            if (res.data.code !== 422) {
                store.state.snackcolor = "green";
                store.state.snackbar = true;
                store.state.snackmsg = res.data.msg;
                commit("CHANGE_UPDATE_STATUS", true);
            } else {
                commit("UPDATE_LOADING", false);
                commit("CHANGE_ERROR_STATUS", true);
            }
        });
    },
    getServerOptionsAction({ commit }) {
        commit("UPDATE_LOADING", true);
        getServer().then((res) => {
            const newServerOptions = res.data.map((item) => {
                return { name: item.server_name, value: item.id };
            });
            commit("UPDATE_SERVER_OPTIONS", newServerOptions);
            commit("UPDATE_LOADING", false);
        });
    },
    getBridgeOptionsAction({ commit, state }) {
        getBridge().then((res) => {
            const newBridgeOption = res.data.map((item) => {
                return { name: item.bridge_name, value: item.id };
            });
            state.bridgeOptions = newBridgeOption;
            commit("UPDATE_LOADING", false);
        });
    },
    getSecurityOptionsAction({ commit }, data) {
        commit("UPDATE_LOADING", true);
        getSecurity({ server_id: data.join(",") }).then((res) => {
            const serverReference = {};
            state.serverOptions.map(
                (item) => (serverReference[item.value] = item.name)
            );
            let newSecurityOptions = [];
            res.data.map((item) => {
                if (!!item.name) {
                    newSecurityOptions.push({
                        name:
                            item.name +
                            " (" +
                            serverReference[item.server_id] +
                            ")",
                        value: item.server_id + ":" + item.index,
                    });
                }
            });
            commit("UPDATE_SECURITY_OPTIONS", newSecurityOptions);
            commit("UPDATE_LOADING", false);
        });
    },
    getSymbolOptionsAction({ commit, state }, data) {
        commit("UPDATE_LOADING", true);
        getSymbol(data).then((res) => {
            let result = [];
            if (Object.keys(data).includes("security")) {
                res.data.map((item) => {
                    const found = state.configData.find(
                        (i) =>
                            i.symbol == item.name &&
                            i.server_id === item.server_id
                    );

                    if (!found) {
                        result.push(item);
                    }
                });
                const newSymbolOptions = result.map((item) => {
                    return {
                        name: item.name,
                        value: item.name + "@" + item.server_id,
                    };
                });
                commit("UPDATE_SYMBOL_OPTIONS", newSymbolOptions);
                commit("UPDATE_LOADING", false);
            } else {
                res.data.map((item) => {
                    const found = state.configData.find(
                        (i) =>
                            i.symbol == item.name &&
                            i.bridge_id === item.bridge_id
                    );

                    if (!found) {
                        result.push(item);
                    }
                });
                const newSymbolOptions = result.map((item) => {
                    return {
                        name: item.name,
                        value: item.name + "@" + item.bridge_id,
                    };
                });
                commit("UPDATE_SYMBOL_OPTIONS", newSymbolOptions);
                commit("UPDATE_LOADING", false);
            }
        });
    },
    getConfigForAlertAction({ commit, state }, selectedAlert) {
        state.selectedAlertConfig = selectedAlert;
        commit("UPDATE_CONFIG_DIALOG", true);
        commit("UPDATE_LOADING", true);
        const typeName = selectedAlert.toLowerCase().replaceAll(" ", "-");
        getConfig(typeName).then((res) => {
            commit("GET_CONFIG_DATA", res.data);
            commit("UPDATE_LOADING", false);
        });
    },
    getOptionsAction({ state }) {
        getOptions("symbol").then((res) => {
            state.options.symbol_regx = res.data || [];
            state.options.filter_symbol = res.data || [];
        });
        getOptions("group").then((res) => {
            state.options.group_regx = res.data || [];
            state.options.filter_group = res.data || [];
        });
        getOptions("security").then((res) => {
            state.options.symbol_group = res.data || [];
            state.options.filter_symbol_group = res.data || [];
        });
        getOptions("login").then((res) => {
            state.options.filter_login = res.data || [];
        });
    },
};

const mutations = {
    GET_CONFIG_DATA(state, data) {
        state.configData = data;
        state.isLoading = false;
    },
    CHANGE_UPDATE_STATUS(state, data) {
        state.updated = data;
    },
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_CONFIG_DIALOG(state, data) {
        state.configDialog = data;
    },
    CHANGE_ERROR_STATUS(state, data) {
        state.errorOccur = data;
    },
    CHANGE_TAB(state, data) {
        state.tabName = data;
    },
    UPDATE_SERVER_OPTIONS(state, data) {
        state.serverOptions = data;
    },
    UPDATE_SECURITY_OPTIONS(state, data) {
        state.securityOptions = data;
    },
    UPDATE_SYMBOL_OPTIONS(state, data) {
        state.symbolOptions = data;
    },
    UPDATE_BOOK_OPTIONS(state, data) {
        state.options["book_regx"] = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
